export type Season = 'spring' | 'summer' | 'autumn' | 'winter';

export type WeatherType = 'clear' | 'cloudy' | 'rain' | 'fog' | 'wind' | 'storm' | 'snow' | 'frost';

export interface SeasonProductionModifiers {
  readonly wood: number;
  readonly stone: number;
  readonly food: number;
  readonly gold: number;
  readonly fish: number;
  readonly movement: number;
}

export interface SeasonState {
  readonly currentSeason: Season;
  readonly year: number;
  readonly seasonDay: number;
  readonly seasonProgress: number;
  readonly currentWeather: WeatherType;
  readonly temperature: number;
  readonly humidity: number;
  readonly snowCoverage: number;
  readonly iceCoverage: number;
  readonly production: SeasonProductionModifiers;
  readonly missingSeasonTiles: readonly string[];
}

export const seasonLabels: Record<Season, string> = {
  spring: 'Frühling',
  summer: 'Sommer',
  autumn: 'Herbst',
  winter: 'Winter',
};

export const weatherLabels: Record<WeatherType, string> = {
  clear: 'klar',
  cloudy: 'bewölkt',
  rain: 'Regen',
  fog: 'Nebel',
  wind: 'Wind',
  storm: 'Gewitter',
  snow: 'Schnee',
  frost: 'Frost',
};

export const weatherSymbols: Record<WeatherType, string> = {
  clear: '☀️',
  cloudy: '☁️',
  rain: '🌧️',
  fog: '🌫️',
  wind: '💨',
  storm: '⛈️',
  snow: '🌨️',
  frost: '❄️',
};
